<mat-card class=" ">
  <mat-card-header class="titreFrm">
    <mat-card-title>PARAM&Eacute;TRE COMPTENCE</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div *ngIf="exist;else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <mat-card class="example-card carClass">
      <mat-card-content>
        <form class="example-form" #f="ngForm">
          <mat-form-field     appearance="outline"  style="width: 70px;">
            <mat-label>Code</mat-label>
            <input [disabled]="true" matInput name="GRHComp_Code" #GRHComp_Code="ngModel" [(ngModel)]="data.GRHComp_Code"
              placeholder="Code" required>
          </mat-form-field>
          <mat-form-field     appearance="outline"  style="width: 250px;">
            <mat-label>Type</mat-label>
            <input matInput name="GRHComp_Libelle" #GRHComp_Libelle="" [(ngModel)]="data.GRHComp_Libelle"
              placeholder="Type" required>
          </mat-form-field>
          <span class="button-row">
            <button (click)="ajouter(f)" [disabled]="!exist" mat-raised-button class="colorGreen">
              <mat-icon>add</mat-icon>
              Ajouter</button>
          </span>
        </form>
      </mat-card-content>
    </mat-card>
    <mat-card class="example-card carClass">
      <mat-card-content>
        <app-avt-listes #listeAlectComponen [showFilter]="true" [heightTable]="'400'" [dataSourceBrut]="datasource"
          [displayedColumnsBrut]="Columns" [listBtn]="listBtnCompetance" (btnTable)="clickBtnHeat($event)">
        </app-avt-listes>
      </mat-card-content>
    </mat-card>
    <br>
  </mat-card-content>
</mat-card>